import {Vue} from 'ui.vue';
import {ProgressBar} from 'itrkomi.vue.progress_bar'
import "itrkomi.vue.adapters"
import "itrkomi.vue.alert";
import "itrkomi.vue.popup";
const candidateReIndexing = {
    template:
        `<div>
            <v-alert v-model="alertShow" :type="alertType" :text="alertText"></v-alert>
            <v-popup v-if="started" @close="stopIndexing">
             <template slot="header"><h3>Переиндексация кандидатов</h3></template>
             <template slot="body">
                  <progressBar :val="progressVal" :size="30" :max="100" :text="progressText"></progressBar>
            </template>
             <template slot="footer"><button @click="stopIndexing" class="button__reset">Остановить</button></template>
            </v-popup>
             
        </div>`,
    components: {
        ProgressBar
    },
    created: function () {

    },
    mounted: function () {

    },
    computed:{
        progressText(){
            return `Проиндексированно: ${this.pagination.current*this.pagination.size}/${!!this.pagination.recordCount?this.pagination.recordCount:0}`;
        },
        progressVal(){
           if(this.pagination.current == null || this.pagination.count == null){
               return 0;
           }
            return parseInt(this.pagination.current)/parseInt(this.pagination.count)*100;

        }
    },
    props: {
        started: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'started',
        event: 'stopped'
    },
    watch: {
        async started(newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                 this.startIndexing();
            }
        },
    },
    data() {
        return {
            alertShow: false,
            alertType: 'danger',
            alertText: '',
            pagination: {
                recordCount: null,
                count: null,
                current: null,
                id: "",
                size: null
            },
        }
    },

    methods: {
        alert(text = "", type = "success") {
            this.alertText = text;
            this.alertType = type;
            this.alertShow = true;
        },
        onError(e) {
            this.alert(e.errors.reduce(function (str, error) {
                str += "<br>" + error.message;
                return str;
            }, ""), "danger");
            this.pagination.current = 1;
            this.stopIndexing();
        },
        process(page = 1) {
            return BX.ajax.runAction(`ajax:routs.es.SearchController.reIndexCandidates`,
                {
                    data: {
                        page: page
                    }
                })
                .then(this.$baseAdapter)
                .then(this.updatePagination)
                .catch(this.onError);
        },
        setDefaultPagination(){
            this.pagination = {
                recordCount: null,
                count: null,
                current: null,
                id: "",
                size: null
            };
        },
        updatePagination(data){
            if (data.pagination) {
                this.pagination = data.pagination;
            }
            const p = new BX.Promise();
            p.resolve(data);
            return p;
        },
        async startIndexing() {
            let isError = false;
            let lastData = null;
            try {

                lastData = await this.process(1);
                if (this.pagination.count > 1 &&  this.pagination.count >= this.pagination.current) {
                    for (let i = this.pagination.current; i <= this.pagination.count; i++) {
                        if(!this.started){
                            throw {errors:[new Error('Индексация остановлена')]};
                        }
                        lastData = await this.process(i);
                    }
                }
            } catch (e) {
                isError = true;
                this.onError(e);

            }
            this.setDefaultPagination();
            this.stopIndexing();


        },
        stopIndexing() {
            this.$emit('stopped',false)
        },
    }
}
export {
    candidateReIndexing
}